import '@xterm/xterm/css/xterm.css';
import { observer } from 'mobx-react';
import React, { useEffect, useRef } from 'react';
import { useTinkerBoxConnection } from '../hooks/useTinkerBoxConnection';
import { TinkerBoxConnectionStore } from '../stores/TinkerBoxConnectionStore';
import { Theme } from './ThemeMaker/types';

interface TinkerBoxConnectProps {
  className?: string;
  onThemeChange?: (theme: Theme) => void;
  focus?: boolean;
  tinkerBoxConnection: TinkerBoxConnectionStore;
}

export const TinkerBoxConnect: React.FC<TinkerBoxConnectProps> = observer(
  ({ className, focus, tinkerBoxConnection }) => {
    const ref = useRef<HTMLDivElement | null>(null);

    const tinkerBoxConnect = useTinkerBoxConnection({
      tinkerBoxConnection,
      container: ref
    });

    useEffect(() => {
      if (focus) {
        tinkerBoxConnect.terminal.focus();
      }
    }, [focus, tinkerBoxConnect]);

    useEffect(() => {
      return () => {
        // tinkerBoxConnect.logout();
      };
    }, [tinkerBoxConnect]);

    return (
      <div
        ref={ref}
        className={`${
          className || ''
        } w-full flex-grow overflow-hidden tinkerbox-connect border-transparent px-2`}
      ></div>
    );
  }
);
